//trade simulator data
export const GET_VALUE_BACKTEST_REQUEST = "GET_VALUE_BACKTEST_REQUEST"
export const GET_VALUE_BACKTEST_SUCCESS = "GET_VALUE_BACKTEST_SUCCESS"
export const GET_VALUE_BACKTEST_ERROR = "GET_VALUE_BACKTEST_ERROR"

